import IconSaveSuccess from '@op/assets/svg/icon-save-success.svg';

export type SymbolType =
  | 'coordinate'
  | 'table'
  | 'card'
  | 'line'
  | 'cloud'
  | 'pie'
  | 'bar'
  | 'block'
  | 'common-bar'
  | 'sentiment-s-bar'
  | 'sentiment-h-bar'
  | 'fullscreen'
  | 'copy'
  | 'refresh'
  | 'download'
  | 'stack_line'
  | 'common-th-bar'
  | 'stacked-common-bar'
  | 'vs'
  | 'bar-line'
  | 'save'
  | 'save_success'
  | 'view_details'
  | 'edit'
  | 'stacked-table';

export type IconType = {
  icon: string;
  symbol: SymbolType;
  tip?: string;
  rotate?: number;
  isImg?: boolean;
};

export const tableIcon: IconType = {
  icon: 'sheet',
  symbol: 'table',
  tip: 'Table',
};

export const cardIcon: IconType = {
  icon: 'card',
  symbol: 'card',
  tip: 'Card',
};

export const lineIcon: IconType = {
  icon: 'discount-chart',
  symbol: 'line',
  tip: 'Line chart',
};

export const cloudIcon: IconType = {
  icon: 'earch-other',
  symbol: 'cloud',
  tip: 'Word Cloud chart',
};
// tip可能不一样
export const coordinateIcon: IconType = {
  icon: 'earch-other',
  symbol: 'coordinate',
  tip: 'Scatter chart',
};

export const pieIcon: IconType = {
  icon: 'pie-chart-icon',
  symbol: 'pie',
  tip: 'Pie chart',
};

export const barIcon: IconType = {
  icon: 'column-chart',
  symbol: 'bar',
  tip: 'Bar chart',
};

export const barLineIcon: IconType = {
  icon: 'chart-rank',
  symbol: 'bar-line',
  tip: 'Bar chart',
};

export const stackLineIcon: IconType = {
  icon: 'stack-diagram',
  symbol: 'stack_line',
  tip: 'Stacked chart',
};

export const blockIcon: IconType = {
  icon: 'chart-treemap',
  symbol: 'block',
  tip: 'Block chart',
};

export const barSIcon: IconType = {
  icon: 'serial-diagram',
  symbol: 'sentiment-s-bar',
  tip: 'Bar chart',
};

export const barHIcon: IconType = {
  icon: 'comparison_sort',
  symbol: 'sentiment-h-bar',
  tip: 'Bar chart',
};
export const commonBarHIcon: IconType = {
  icon: 'comparison_sort',
  symbol: 'common-bar',
  tip: 'Bar chart',
};

export const commonStackedBarHIcon: IconType = {
  icon: 'comparison_sort',
  symbol: 'stacked-common-bar',
  tip: 'Bar chart',
};

export const commonBarTHIcon: IconType = {
  icon: 'serial-diagram',
  symbol: 'common-th-bar',
  rotate: 270,
  tip: 'Diverging Chart',
};

export const fullIcon: IconType = {
  icon: 'scale',
  symbol: 'fullscreen',
  tip: 'Enlarge',
};

export const copyIcon: IconType = {
  icon: 'copy-new',
  symbol: 'copy',
  tip: 'Copy',
};

export const refreshIcon: IconType = {
  icon: 'refresh',
  symbol: 'refresh',
  tip: 'Regenerate',
};

export const downloadIcon: IconType = {
  icon: 'download',
  symbol: 'download',
  tip: 'Download',
};

export const vsIcon: IconType = {
  icon: 'vs-icon',
  symbol: 'vs',
  tip: 'Comparison Analysis',
};

export const saveIcon: IconType = {
  icon: 'datalab-save',
  symbol: 'save',
  tip: 'Save Analysis',
};

export const saveSuccessIcon: IconType = {
  isImg: true,
  icon: IconSaveSuccess,
  symbol: 'save_success',
  tip: 'Save Analysis Success',
};

export const viewDetailsIcon: IconType = {
  icon: 'view-details-icon',
  symbol: 'view_details',
  tip: 'Summary Detail',
};

export const editIcon: IconType = {
  icon: 'pencil',
  symbol: 'edit',
  tip: 'Edit Repeat Settings',
};

export const stackedTableIcon: IconType = {
  icon: 'comparison_sort',
  symbol: 'stacked-table',
  tip: 'Bar chart',
};
